import createJobOverview from "./ajaxJobFinder";

const setFiltersOnCheck = () => {
 if(document.querySelector('.ume-career-radio')){
     const superBoxes = document.querySelectorAll('.ume-career-super-box');
     const mainBoxes = document.querySelectorAll('.ume-career-main-box');
     const subBoxes = document.querySelectorAll('.ume-career-sub-box');
     const allDataFilters = document.querySelectorAll('.ume-career-category-filter');
     let inputField = document.querySelector('.ume-career-search-trigger').previousElementSibling;
     superBoxes.forEach(box =>{
         box.addEventListener('change', ev =>{
            if(inputField !== null){
                inputField.value = '';
            }

             superBoxes.forEach( r => {
                 if(r !== ev.target)  r.checked = false;
             })
             if(box.checked){
                 let allNotSuperHolder = document.querySelectorAll('.ume-career-not-super-holder');
                 allNotSuperHolder.forEach(holder =>{
                     holder.classList.add('ume-career-initially-hidden');
                     holder.querySelector('.ume-career-category-filter').setAttribute('data-filter', '');
                 })
                 let allCheckboxes = document.querySelectorAll('.ume-non-super-box');
                 allCheckboxes.forEach(checkbox => {
                     checkbox.checked = false;
                 })

                 let targetName = box.name;
                 let parent = box.closest('.ume-career-category-filter');
                 parent.setAttribute('data-filter', targetName);
                 let target = box.id;
                 let children = document.querySelectorAll(`[data-parent-name="${target}"]`);
                 children.forEach(child =>{
                     child.classList.remove('ume-career-initially-hidden');
                 })
             }

         })
     })
     mainBoxes.forEach(checkbox =>{
         checkbox.addEventListener('change', ev =>{
             if(inputField !== null){
                 inputField.value = '';
             }
             mainBoxes.forEach( r => {
                 if(r !== ev.target)  r.checked = false;
             })
             let target = checkbox.id;
             let children = document.querySelectorAll(`[data-filter-target="${target}"]`);
             let allSubHolders = document.querySelectorAll('.ume-career-sub-sub-holder');
             let allCheckboxes = document.querySelectorAll('.ume-career-checkbox');
             allCheckboxes.forEach(checkbox => {
                 checkbox.checked = false;
             })
             allSubHolders.forEach(holder =>{
                 holder.classList.add('ume-career-initially-hidden');
                 holder.querySelector('.ume-career-category-filter').setAttribute('data-filter', '');
             })
             if(checkbox.checked){
                 if(children.length > 0){
                     children.forEach(child =>{
                         child.classList.remove('ume-career-initially-hidden');
                     })
                 }

              let filter = checkbox.closest('.ume-career-category-filter');
                 filter.setAttribute('data-filter', checkbox.name);
             } else {
                 if(children.length > 0){
                     children.forEach(child =>{
                         child.classList.add('ume-career-initially-hidden');
                         let coolBoxes = child.querySelectorAll('.ume-career-sub-box');
                         let coolFilterHolder = child.querySelector('.ume-career-category-filter');
                         coolFilterHolder.setAttribute('data-filter', '');
                         coolBoxes.forEach(b => {
                             b.checked = false;
                         })
                     })
                 }
             }

         })
     })
     subBoxes.forEach(checkbox =>{
         checkbox.addEventListener('change', ev =>{
             if(inputField !== null){
                 inputField.value = '';
             }
             const filter = checkbox.closest('.ume-career-category-filter');
             let terms = filter.getAttribute('data-filter');
             let term_array = terms.split('|');
             term_array = term_array.filter(e => e); // remove empty
             if(checkbox.checked){


                 if(!term_array.includes(checkbox.name)){
                     term_array.push(checkbox.name);


                 }
             } else {
                 if (term_array.includes(checkbox.name)) {
                     let index = term_array.indexOf(checkbox.name);
                     term_array.splice(index, 1);
                 }
             }
             terms = term_array.join('|');
             filter.setAttribute('data-filter', terms);
             if(terms == ''){
                 createJobOverview(document.querySelector('[data-filter-type="super"]') ? document.querySelector('[data-filter-type="super"]').getAttribute('data-filter') : '', document.querySelector('[data-filter-type="main"]') ? document.querySelector('[data-filter-type="main"]').getAttribute('data-filter') : '', '');
             }
         })
     })

     // load more button
     document.addEventListener('click', ev => {
         if(!ev.target.classList.contains('ume-career-finder-results-holder--load-more')){
             return;
         }
         ev.preventDefault();
         if(ev.target.classList.contains('disabled')) return;
         let spinner = document.querySelector('.ume-career-finder-results-holder--load-more-spinner');
         if(spinner !== null){
             spinner.classList.remove('d-none');
         }
         let counterElement = document.querySelectorAll('.ume-career-job-link-holder:last-child');
         let lastStep = counterElement[0].getAttribute('data-step');
         let newStep = parseInt(lastStep) + 1;
         let inputField = document.querySelector('.ume-career-search-trigger').previousElementSibling;
         createJobOverview(document.querySelector('[data-filter-type="super"]') ? document.querySelector('[data-filter-type="super"]').getAttribute('data-filter') : '', document.querySelector('[data-filter-type="main"]') ? document.querySelector('[data-filter-type="main"]').getAttribute('data-filter') : '',  document.querySelector('[data-filter-type="sub"]') ? document.querySelector('[data-filter-type="sub"]').getAttribute('data-filter') : '', inputField.value, newStep);
     })
     // reset button
     document.addEventListener('click', ev => {
         if(!ev.target.classList.contains('ume-career-reset-filter')){
             return;
         }

         ev.target.classList.add('disabled');
         ev.target.setAttribute('aria-disabled', 'true');
        setTimeout(() => {
            ev.target.classList.remove('disabled');
            ev.target.setAttribute('aria-disabled', 'false');
        }, 1000)
         let allNotSuperHolder = document.querySelectorAll('.ume-career-not-super-holder');
         allNotSuperHolder.forEach(holder =>{
             holder.classList.add('ume-career-initially-hidden');
         })
         let allFilters = document.querySelectorAll('.ume-career-category-filter');
         allFilters.forEach(filter =>{
             filter.setAttribute('data-filter', '');
         })
         let allRadioButtons = document.querySelectorAll('.ume-career-radio');
        let allCheckboxes = document.querySelectorAll('.ume-career-checkbox');
         allRadioButtons.forEach( radio  => {
             radio.checked = false;
             radio.dispatchEvent(new Event('change'));
         })
         allCheckboxes.forEach(checkbox => {
             if(checkbox.checked !== false){
                 checkbox.checked = false;
                 checkbox.dispatchEvent(new Event('change'));
             }

         })
        // reset search input
         let inputField = document.querySelector('.ume-career-search-trigger').previousElementSibling;
        inputField.value = '';
        // reset url without refreshing
         window.history.pushState({}, document.title, '/job-finder/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1).split('?')[0]);
         createJobOverview();
     })
 }

}
export default  setFiltersOnCheck;